import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PhoneCall, Mail, MonitorSmartphone } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CONTACT } from "@/lib/data";

const OPTIONS = [
  {
    icon: PhoneCall,
    title: "Emergency phone support",
    detail: CONTACT.phone,
    href: `tel:${CONTACT.phone.replace(/\s/g, "")}`,
    testid: "support-option-phone",
    chip: "bg-forest text-blue-300",
  },
  {
    icon: WhatsAppIcon,
    title: "WhatsApp us",
    detail: "Chat with an engineer now",
    href: CONTACT.whatsapp,
    testid: "support-option-whatsapp",
    chip: "bg-[#25D366] text-white",
    external: true,
  },
  {
    icon: Mail,
    title: "Raise a ticket",
    detail: CONTACT.supportEmail,
    href: `mailto:${CONTACT.supportEmail}`,
    testid: "support-option-email",
    chip: "bg-forest text-blue-300",
  },
  {
    icon: MonitorSmartphone,
    title: "Remote quick-join",
    detail: "Start an AnyDesk / TeamViewer session",
    href: `mailto:${CONTACT.supportEmail}?subject=Remote%20session%20request`,
    testid: "support-option-remote",
    chip: "bg-forest text-blue-300",
  },
];

export const SupportModal = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="support-modal" className="sm:max-w-md bg-card">
      <DialogHeader>
        <DialogTitle className="font-display text-xl">Existing client support</DialogTitle>
        <DialogDescription>
          Need rapid technical help? Choose whichever route suits you best.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3 pt-2">
        {OPTIONS.map((opt) => (
          <a
            key={opt.title}
            href={opt.href}
            data-testid={opt.testid}
            {...(opt.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            className="flex items-center gap-4 rounded-xl border border-border bg-muted/40 p-4 transition-all duration-200 hover:-translate-y-0.5 hover:border-primary/50 hover:bg-muted"
          >
            <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-lg ${opt.chip}`}>
              <opt.icon className="h-5 w-5" />
            </span>
            <span>
              <span className="block font-semibold text-sm">{opt.title}</span>
              <span className="block text-sm text-muted-foreground">{opt.detail}</span>
            </span>
          </a>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
